// Initialize global dev logging utilities first (must be before all other imports)
import './utils/devLog';

import { initSentry } from './config/sentry';

// Initialize Sentry first
initSentry();

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeCacheManagement } from './utils/cacheVersion'
import { clearUpdateFlag } from './stores/versionStore'
import { emergencyCacheClear } from './utils/emergencyCacheClear'

// URL-based emergency cache clear: append ?cc=1 to any URL to nuke browser cache and reload
if (new URLSearchParams(window.location.search).get('cc') === '1') {
  emergencyCacheClear().then(() => {
    // Strip the ?cc=1 param and reload clean
    const url = new URL(window.location.href);
    url.searchParams.delete('cc');
    window.location.replace(url.toString());
  });
} else {
  // Initialize cache management before app starts
  initializeCacheManagement();
}

// Clear any stale update flag from a previous session (defense-in-depth)
clearUpdateFlag();

createRoot(document.getElementById("root")!).render(<App />);
